module.exports = __webpack_public_path__ + "static/img/index.7394eef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index.png
// module id = zICw
// module chunks = 56